import React from 'react';
import PropTypes from 'prop-types';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../styles';

const styles = css`
  background-color: ${colors.color2};
  padding: 40px 0;
  margin-top:60px;
  @media (min-width: 992px) {
    margin-top:80px;
    padding: 140px 0 60px 0;
  }
  .InsideHeader_titleWrapper {

  }
  .InsideHeader_preTitle {
    font:italic 400 30px/1.2 ${typography.SansSerif};
    display:block;
    color: ${colors.color5};
    @media (min-width: 992px) {
      font:italic 400 36px/60px ${typography.SansSerif};
    }
  }
  .InsideHeader_title {
    font:400 42px/1 ${typography.SansSerif};
    color: ${colors.color1};
    @media (min-width: 992px) {
      font:400 64px/1 ${typography.SansSerif};
    }
  }
  .InsideHeader_title:after {
    content:"";
    width: 80px;
    height:8px;
    background-color: ${colors.color5};
    display:block;
    margin:30px 0;
    @media (min-width: 992px) {
      margin:30px 0;
      width: 100px;
      height:10px;
    }
  }
  .InsideHeader_leadText {
    font:400 16px/34px ${typography.SansSerif};
    @media (min-width: 992px) {
      font:400 18px/40px ${typography.SansSerif};
    }
  }
`;

function InsideHeader({ h1, h1Pre, h1Post, background, leadText }) {
  const mediaStyle = {};
  if (background) {
    mediaStyle.backgroundImage = `url('${buildThumbnailUrl(background, { width: 2000, height: 2000 })}')`;
  }
  return (
    <div
      className={styles}
      style={mediaStyle}
    >
      <div className="InsideHeader_titleWrapper container">
        <div className="row">
          <h1 className="InsideHeader_title col-md-5">
            {h1Pre && <span className="InsideHeader_preTitle">{h1Pre}</span>}
            {h1}
            {h1Post && <span className="InsideHeader_postTitle">{h1Post}</span>}
          </h1>
          <div className="InsideHeader_leadText col-md-7">{leadText}</div>
        </div>
      </div>
    </div>
  );
}

InsideHeader.propTypes = {
  h1: PropTypes.string.isRequired,
  h1Pre: PropTypes.string,
  h1Post: PropTypes.string,
  leadText: PropTypes.string,
  background: PropTypes.string,
};

InsideHeader.defaultProps = {
  h1Pre: undefined,
  h1Post: undefined,
  leadText: undefined,
  background: undefined,
};

export default InsideHeader;



// WEBPACK FOOTER //
// ./src/components/InsideHeader.js